import React, { useEffect, useState } from "react";
import CrearTipoUsuario from "../../../components/admin/rangos/rangos";
import ListadoAreas from "../../../components/admin/rangos/listadoRangos";

const initialState = {
  tipo: "",
  code: "",
  rango_init: "",
  rango_end: "",
  pre_tipo_usuario_id:""
};
const Rangos = () => {
  const [updateList, setUpdateList] = useState(false);
  const [type, setType] = useState("save");
  const [state, setState] = useState(initialState);
  useEffect(() => {
    return () => {};
  }, []);

  const updateListFn = () => {
    setUpdateList(!updateList);
  };

  const resetState = () => {
    setState(initialState);
  };
  return (
    <div className="h-100 px-3 bgfondo2 d-flex justify-content-start flex-column ">
      <CrearTipoUsuario
        updateListFn={updateListFn}
        state={state}
        setState={setState}
        type={type}
        setType={setType}
        resetState={resetState}
      />
      <ListadoAreas
        updateList={updateList}
        updateListFn={updateListFn}
        setState={setState}
        setType={setType}
      />
    </div>
  );
};

export default Rangos;
